<template>
  <b-nav-item-dropdown right no-caret class="d-md-down-none">
    <!--  style="min-width: 140px;" -->
    <template slot="button-content">
      <img
        v-show="!hideFlag"
        class="flag"
        :src="'/static/img/flags/' + currentLanguage + '.png'"
        :alt="currentLanguage"
        style="max-width: 32px"
      />
      {{ uniTranslation(currentLanguage) }}
    </template>
    <b-dropdown-item v-for="lang in languages" :key="lang" @click="changeLanguage(lang)">
      <img
        v-show="!hideFlag"
        class="flag"
        :src="'/static/img/flags/' + lang + '.png'"
        :alt="lang"
        style="max-width: 32px"
      />
      {{ uniTranslation(lang) }}</b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>
<script>
// import { loadLanguageAsync } from "../../i18n/index";
import { mapGetters } from "vuex";
export default {
  name: "HeaderDropdown",
  data: () => {
    return {};
  },
  computed: {
    ...mapGetters(["currentLanguage", "languages", "hideFlag"])
  },
  methods: {
    changeLanguage: function(lang) {
      if (lang !== this.currentLanguage) {
        this.$store.dispatch("changeLanguage", lang);
      }
    }
  }
};
</script>
<style lang="scss">
.flag {
  width: 24px;
  position: relative;
  top: -2px;
  margin-right: 3px;
  border: 1px darkgrey solid;
}
</style>
